"use client"

import React from "react"
// import Link from "next/link"
import * as classes from "./header.module.scss"
import BookingModal from "@/components/Modal/bookingModal"

const Header2 = ({ theme, bookMeetingData }) => {
	const [modalIsOpen, setIsOpen] = React.useState(false)
	const { websiteUrl, logoImageUrl, contactUsLinkUrl } = theme
	function openModal() {
		setIsOpen(true)
	}

	function closeModal() {
		setIsOpen(false)
	}

	return (
		<>
			<div className=" w-full" style={{ backgroundColor: theme.generalBackgroundColor, }}>
				<div className="flex  justify-between  items-center   md:px-6  md:py-4 py-3 px-2.5 ">
					<a
						href={websiteUrl}
						target="_blank"
						rel="noreferrer"
						className="cursor-pointer"
					>
						{/* <img src={logoImageUrl} alt="home logo" /> */}
						<img
							src={logoImageUrl}
							alt="home logo"
							className="h-[38px]
                lg:h-[42px]
                w-auto
                smd:h-[76px]
                ыыmax-w-[200px]
                object-contain
              "
						/>
					</a>

					<div className="flex gap-4">
						<a
							href="/"
							className="
							hidden
							md:block
										text-sm
                    font-normal
										leading-[120%]
										md:leading-[125%]
                    rounded-full
                    border
                    py-3
                    px-4
                    lg:py-3
                    lg:text-base
                    cursor-pointer
                    hover:opacity-90"
							style={{
								fontFamily: theme.fontFamilyPrimary,
								backgroundColor: 'transparent',
								color: theme.primaryFontColor,
								borderColor: theme.primaryFontColor,
							}}
						>
							See More Stories
						</a>
						{bookMeetingData.calendarLink && bookMeetingData.meetingContact ? (
							<>
								<button
									onClick={openModal}
									style={{
										fontFamily: theme.fontFamilyPrimary,
										backgroundColor: theme.accentBackgroundColor,
										color: theme.accentPrimaryFontColor
									}}
									className="
                    text-sm
                    font-light
                    border
                    border-transparent
                    rounded-full
										leading-[120%]
										md:leading-[125%]
                    py-3
                    px-4
                    lg:py-3
                    lg:text-base
                    cursor-pointer
                    hover:opacity-90
                  "
								>
									Book a Meeting
								</button>
								<BookingModal
									bookMeetingData={bookMeetingData}
									modalIsOpen={modalIsOpen}
									openModal={openModal}
									closeModal={closeModal}
								/>
							</>
						) : (
							<a
								href={contactUsLinkUrl}
								target="_blank"
								rel="noreferrer"
							>
								<button
									style={{
										fontFamily: theme.fontFamilyPrimary,
										backgroundColor: theme.accentBackgroundColor,
										color: theme.accentPrimaryFontColor
									}}
									className="
                    text-sm
                    font-light
                    border
                    border-transparent
                    rounded-full
										leading-[120%]
										md:leading-[125%]
                    md:text-base
                    px-4
                    py-3
                    cursor-pointer
                    hover:opacity-90
                  "
								>
									Contact Us
								</button>
							</a>
						)}
					</div>
				</div>
			</div>
		</>
	)
}

export default Header2
	// <a
	// 							href={contactUsLinkUrl}
	// 							target="_blank"
	// 							rel="noreferrer"
	// 						>
	// 							<button
	// 								style={{
	// 									fontFamily: theme.fontFamilyPrimary,
	// 									backgroundColor: theme.accentBackgroundColor,
	// 									color: theme.accentPrimaryFontColor
	// 								}}
	// 								className="
  //                   text-sm
  //                   font-light
  //                   border
  //                   border-transparent
  //                   rounded-full
  //                   /px-3
  //                   /py-2
	// 									leading-[120%]
	// 									md:leading-[125%]
  //                   md:text-base
  //                   px-4
  //                   /md:px-4
  //                   py-3
  //                   /md:py-3
  //                   cursor-pointer
  //                   hover:opacity-90
  //                 "
	// 							>
	// 								Contact Us
	// 							</button>
	// 						</a>
// import React from "react"
// import Link from "next/link"
// import * as classes from "./header.module.scss"
// import BookingModal from "@/components/Modal/bookingModal"

// const Header = ({ theme, bookMeetingData }) => {
//   const [modalIsOpen, setIsOpen] = React.useState(false)
//   const { websiteUrl, logoImageUrl, contactUsLinkUrl } = theme
//   function openModal() {
//     setIsOpen(true)
//   }

//   function closeModal() {
//     setIsOpen(false)
//   }

//   return (
//     <>
//       <div
//         className={classes[`${true ? "headerWrapperScroll" : "headerWrapper"}`]}
//       >
//         <div className={classes["headerSubWrapper"]}>
//           <a className={classes["homeIcon"]} href={websiteUrl} target="_blank">
//             <img src={logoImageUrl} alt="home logo" />
//           </a>

//           <div className={classes["navbarRightSection"]}>
//             {/*<Link className={classes["contactIcon"]} href={`/`} target="_blank">
//               <button
//                 style={{
//                   color: theme.primaryFontColor,
//                   backgroundColor: "transparent",
//                   borderColor: theme.primaryFontColor,
//                   fontFamily: theme.fontFamilyPrimary,
//                 }}
//               >
//                 See More Stories
//               </button>
//             </Link>*/}
//             {bookMeetingData.calendarLink && bookMeetingData.meetingContact ? (
//               <a
//                 className={classes["contactIcon"]}
//                 target="_blank"
//                 rel="noreferrer"
//               >
//                 <button
//                   onClick={openModal}
//                   style={{
//                     fontFamily: theme.fontFamilyPrimary,
//                     backgroundColor: theme.accentBackgroundColor,
//                     color: theme.accentPrimaryFontColor,
//                     border: "None",
//                   }}
//                 >
//                   Book A Meeting
//                 </button>
//               </a>
//             ) : (
//               <a
//                 className={classes["contactIcon"]}
//                 href={contactUsLinkUrl}
//                 target="_blank"
//                 rel="noreferrer"
//               >
//                 <button
//                   style={{
//                     fontFamily: theme.fontFamilyPrimary,
//                     backgroundColor: theme.accentBackgroundColor,
//                     borderColor: theme.accentBackgroundColor,
//                     color: theme.accentPrimaryFontColor,
//                   }}
//                 >
//                   Contact Us
//                 </button>
//               </a>
//             )}
//             {bookMeetingData.calendarLink && bookMeetingData.meetingContact && (
//               <BookingModal
//                 bookMeetingData={bookMeetingData}
//                 modalIsOpen={modalIsOpen}
//                 openModal={openModal}
//                 closeModal={closeModal}
//               />
//             )}
//           </div>
//         </div>
//       </div>
//     </>
//   )
// }

// export default Header
